import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { IconClose as CloseButton } from 'components/SVG/IconClose'
import { useRouter } from 'next/router'
import { getCookieValue } from 'services/utils/cookie'
import { isFromFoundApp } from 'utils/device-utils'
import { CookiesMap } from 'utils/cookies'

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  background: ${props => props.theme.colors.bianca};
  width: 100%;
  user-select: none;
`

const Container = styled.div`
  margin: 24px auto;
  max-width: 900px;
  padding: 0 20px;

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    margin: 20px 0;
    max-width: unset;
  }
`

const Right = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 5px;
`

const Text = styled.div`
  color: ${props => props.theme.colors.black};
  text-align: left;
  font-size: 13px;
  cursor: pointer;
`

const Button = styled.div`
  background: ${props => props.theme.colors.opal};
  color: ${props => props.theme.colors.heavyMetal};
  border-radius: 50px;
  margin-top: 10px;
  padding: 5px 7px;
  max-width: 100px;
  font-size: 13px;
  font-weight: 700;
  box-sizing: border-box;
  cursor: pointer;
`

const CookiePolicy = () => {
  const router = useRouter()
  const [showBanner, setShowBanner] = useState<boolean>(false)

  useEffect(() => {
    const isOneTrustConsentActive = getCookieValue(CookiesMap.OneTrustConsent)
    if (isOneTrustConsentActive) {
      // OneTrust banner is active, don't show the local cookie banner
      setShowBanner(false)
      return
    }
    const isFoundApp = isFromFoundApp()
    if (isFoundApp) {
      setShowBanner(false)
      return
    }
    const cookieConsent = getCookieValue(CookiesMap.cookieConsent)
    if (cookieConsent === null || !['accepted', 'rejected'].includes(cookieConsent)) {
      setShowBanner(true)
    }
  }, [])

  const onClose = () => {
    setShowBanner(false)
  }

  const setCookie = () => {
    const date = new Date()
    date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000)
    const expires = 'expires=' + date.toUTCString()
    let cookieString = CookiesMap.cookieConsent + '=accepted; ' + expires + '; path=/;'
    if (process.env.NODE_ENV === 'production' && process.env.STORE_URL) {
      cookieString += `domain=.${process.env.STORE_URL.split('https://')[1]};`
    }
    document.cookie = cookieString
    onClose()
  }

  return (
    <>
      {showBanner && (
        <Wrapper id={'cookie-banner'}>
          <Container>
            <Right>
              <CloseButton onClose={onClose} />
            </Right>
            <Text>
              We use cookies (or similar tools) to analyze our website traffic. We also share
              information about your use of our website with advertising and analytics partners. By
              clicking {'"'}Accept{'"'} or continuing to browse our website, you allow us to use and
              share your information as described under our{' '}
              <u
                onClick={() => {
                  router.push(`${process.env.STORE_URL}/pages/privacy-policy`)
                }}
              >
                privacy policy
              </u>
              .
            </Text>
            <Button onClick={setCookie}>Accept</Button>
          </Container>
        </Wrapper>
      )}
    </>
  )
}

export default CookiePolicy
